export let life = {
  render(c) {
    return c('div', {
      attrs: {
        class: 'component-table-page'
      },
      ref: 'cTablePage'
    }, [
      c('div', {
        attrs: {
          class: 'table'
        },
      }, [
        c('private-table', {
          props: {
            tableData: this.data,
            tableProp: this.tableProp,
            tableHeight: this.tableHeight,
            highlightCurrentRow: this.highlightCurrentRow || false,
            order: this.page ? (this.page.page - 1) * this.page.pageSize : 0,
            expand: this.expand,
            useSelection: this.useSelection,
            rowStyle: this.rowStyle,
            height: this.height,
            border:this.border,
            id:this.id,
            showsummary:this.showsummary
          },
          on: {
            select: this.select,
            'select-all': this.selectAll,
            'row-click': this.clickTr,
            'cell-click': this.clickTd,
            'selection-change': this.handleSelectionChange,
            'sort-change': this.sortChange
          },
          scopedSlots: (() => {
            let result = {};
            for (let key in this.$scopedSlots) {
              result[key] = this.$scopedSlots[key];
            }
            return result;
          })()
        }, (() => {
          let result = [];
          for (let key in this.$slots) {
            if (key === 'default') {
              result.push(this.$slots[key]);
            } else {
              result.push(c('slot', {
                slot: key
              }, [this.$slots[key]]));
            }
          }
          return result;
        })())
      ]), c('div', {
        attrs: {
          class: 'page'
        },
      }, this.page && [
        c('el-pagination', {
          props: {
            'page-sizes': [this.defaultPageSize, 20, 30, 40],
            'page-size': this.customPageSize,
            'layout': this.layout ? this.layout : "total, prev, pager, next, jumper",
            'current-page': this.customPage,
            'total': this.total,
            'small': true
          },
          on: {
            'size-change': this.sizeChange,
            'current-change': this.clickPageNum
          }
        })
      ])
    ]);
  },
  created() {
    this.methods('getData');
  },
  mounted() {
    window.utils.WASD();
    // this.$nextTick(() => {
    //   this.methods('setPageSize')
    // })
  }
};
export let event = {
  select() {
    this.methods('emitEvent', 'select', ...arguments);
  },
  selectAll() {
    this.methods('emitEvent', 'select-all', ...arguments);
  },
  clickTd() {
    this.methods('emitEvent', 'cell-click', ...arguments);
  },
  clickTr() {
    this.methods('emitEvent', 'row-click', ...arguments);
  },
  handleSelectionChange() {
    this.methods('emitEvent', 'selection-change', ...arguments);
  },
  sortChange() {
    this.methods('sortChange', ...arguments);
  },
  getData() {
    this.methods('getData');
  },
  // 父组件条件筛选时调用
  outFilter() {
    this.methods('resetAll');
  },
  // 父组件执行入删除某一行等操作需要重新获取这一页数据时调用
  reGetData() {
    this.methods('getData');
  },
  /**
   * 页码变化
   * @param no
   */
  clickPageNum(no) {
    this.customPage = no;
    this.getData();
  },
  /**
   * 每页条数变化
   * @param val
   */
  sizeChange(val) {
    this.customPageSize = val;
    // 重新获取第一页数据
    if (this.customPage === 1) {
      this.getData();
    } else {
      this.customPage = 1;
    }
  },
};
export let watch = {
  // 'data': function () {
  //   if (this.notSlice && this.tableData.length > 0) {
  //     this.notSlice = false
  //     this.data = this.tableData.slice(0, this.defaultPageSize)
  //     this.tableHeight = this.page.size * 48 + 50
  //   }
  // }
};
